import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { EditPrompt } from '../form.types';

@Component({
    selector: 'app-prompt',
    templateUrl: './prompt.component.html',
    styleUrls: ['./prompt.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class PromptComponent implements OnInit {
    @Input() prompt: EditPrompt;
    @Output() clickEvent: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
    constructor() {}

    ngOnInit(): void {}

    infoToolTipClick($event: MouseEvent) {
        if (this.prompt.infoClickCallBack) {
            this.prompt.infoClickCallBack.function.call(this.prompt.infoClickCallBack.this, this.prompt);
        }
    }

    onClick($event: MouseEvent) {
        this.clickEvent.emit($event);
    }
}
